import { inject, Pipe, PipeTransform } from '@angular/core';
import { WcgDateOnlyPipe, WcgDateTimePipe } from '@wcg/frontend-framework';
import { appendUTCOffset } from '../utils/date-offset-calculator.util';

@Pipe({
  name: 'ermDate',
})
export class ERMDatePipe implements PipeTransform {
  private readonly _datePipe = inject(WcgDateOnlyPipe);
  transform(value: string | Date | null | undefined): string {
    if (!value || value === 'None') {
      return 'N/A';
    }
    return this._datePipe.transform(appendUTCOffset(`${value}`));
  }
}

@Pipe({
  name: 'ermDateTime',
})
export class ERMDateTimePipe implements PipeTransform {
  private readonly _dateTimePipe = inject(WcgDateTimePipe);
  transform(value: string | Date | null | undefined): string {
    if (!value || value === 'None') {
      return 'N/A';
    }
    return this._dateTimePipe.transform(appendUTCOffset(`${value}`));
  }
}

@Pipe({
  name: 'ermTime',
})
export class ERMTimePipe implements PipeTransform {
  private readonly _dateTimePipe = inject(WcgDateTimePipe);
  transform(value: string | Date | null | undefined): string {
    if (!value || value === 'None') {
      return 'N/A';
    }
    return this._dateTimePipe.transform(appendUTCOffset(`${value}`));
  }
}
